<template>
    <div>
        <h1 class="subtitle">Ordenes Pendiente de Aprobación</h1>
        <hr />
        <b-table :data="lista" :loading="loading" checkable bordered :checked-rows.sync="selectedRows">
            <template slot-scope="props">
                <b-table-column field="codigo" label="Código">
                    {{ formatCode(props.row) }}
                </b-table-column>
                <b-table-column field="fecha_orden" label="F. Orden">
                    {{ props.row.fecha_orden }}
                </b-table-column>
                <b-table-column field="proveedor" label="Proveedor">
                    {{ props.row.proveedor.razon_social }}
                </b-table-column>
                <b-table-column field="estado" label="Estado">
                    <span class="tag" :class="getOrdenColor(props.row.estado)">
                        {{ props.row.estado.descripcion }}
                    </span>
                </b-table-column>
                <b-table-column field="condicion" label="Condición">
                    {{ props.row.condicion_comercial.descripcion }}
                </b-table-column>
                <b-table-column field="importacion" label="Importación">
                    <b-icon title="Nacional" v-if="!props.row.es_importacion" icon="flag" type="is-success"></b-icon>
                    <b-icon title="Internacional" v-else icon="earth" type="is-info"></b-icon>
                </b-table-column>
                <b-table-column>
                    <a :href="'/orden/approve/' + props.row.id_orden" title="Aprobar"><span class="icon has-text-info">
                            <i class="mdi mdi-check-outline mdi-18px"></i> </span></a>
                </b-table-column>
            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>No se encontraron Ordenes</p>
                    </div>
                </section>
            </template>
        </b-table>
        <br />
        <button class="button is-success" @click="aprobarSeleccionadas" :disabled="selectedRows.length === 0">
            Aprobar
        </button>
    </div>
</template>

<script>
import axios from "axios"
import { purchaseStatus } from "../constants/constants"
import { UsuarioService } from "../services"

export default {
    name: "OrdenListApprove",
    data() {
        return {
            lista: [],
            selectedRows: [],
            loading: false,
        }
    },
    computed: {
        usuario() {
            return UsuarioService.getUsuario()
        },
    },
    methods: {
        listPendingApprove() {
            let idUsuario = this.usuario.usu_id
            this.loading = true
            axios.post("/orden/approve/pending", { id_usuario: idUsuario }).then(
                resp => {
                    this.loading = false
                    this.lista = resp.data
                },
                () => (this.loading = false)
            )
        },
        getOrdenColor(status) {
            const values = Object.values(purchaseStatus)
            let response = "is-light"
            if (status) {
                values.forEach(e => {
                    if (e.id === status.id_orden_estado) {
                        response = e.class
                    }
                })
            }
            return response
        },
        formatCode(row) {
            let codigo = `${row.codigo.toString().padStart(6, "0")}-${row.centro_costo.codigo
                }-${row.tipo_orden === 1 ? "OC" : "OS"}-${row.fecha_orden.substring(
                    0,
                    4
                )}`
            return `${codigo}`
        },
        aprobarSeleccionadas() {
            let idUsuario = this.usuario.usu_id
            axios.post("/orden/approve/massive", this.selectedRows, { headers: { idUsuario: idUsuario } }).then(
                () => {
                    this.listPendingApprove()
                    this.$buefy.toast.open({
                        message: `Se aprobaron las ordenes`,
                        type: "is-success"
                    })
                    this.selectedRows = []
                },
                () => {
                    this.listPendingApprove()
                    this.$buefy.toast.open({
                        message: `Hubo un error al aprobar las ordenes`,
                        type: "is-danger"
                    })
                    this.selectedRows = []
                }
            )
        }
    },
    mounted() {
        this.listPendingApprove()
    }
}
</script>

<style scoped></style>
